import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {BillingAgent, matchBillingAgentByType} from 'ApplicationEntry/models/BillingAgent';
import * as G from 'ApplicationEntry/models/GroupBillingAgent';
import * as NY from 'ApplicationEntry/models/NewYorkBillingAgent';
import * as O from 'ApplicationEntry/models/OrdinaryBillingAgent';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {UserAssignedFormNumber} from 'ApplicationEntry/models/FormNumber';
import {ZipCode} from 'ApplicationEntry/models/ZipCode';

export enum BillingAgentActionType {
  CHANGE_CASE_NUMBER = 'billingAgent/CHANGE_CASE_NUMBER',
  CHANGE_ASYNC_CASE_NUMBER = 'billingAgent/CHANGE_ASYNC_CASE_NUMBER',
  CHANGE_CONTROL_NUMBER = 'billingAgent/CHANGE_CONTROL_NUMBER',
  CHANGE_CASE_NAME = 'billingAgent/CHANGE_CASE_NAME',
  CHANGE_TRANSIT = 'billingAgent/CHANGE_TRANSIT',
  CHANGE_ACCOUNT = 'billingAgent/CHANGE_ACCOUNT',
  CHANGE_DRAFT_DAY = 'billingAgent/CHANGE_DRAFT_DAY',
  GET_ACH_DRAFTDAY = 'billingAgent/GET_ACH_DRAFTDAY',
  CHANGE_BILLING_MODE = 'billingAgent/CHANGE_BILLING_MODE',
  CHANGE_ISSUE_DATE = 'billingAgent/CHANGE_ISSUE_DATE',
  CHANGE_FORM_NUMBER = 'billingAgent/CHANGE_FORM_NUMBER',
  CHANGE_ELECTRONIC_DELIVERY = 'billingAgent/CHANGE_ELECTRONIC_DELIVERY',
  CHANGE_PAYOR = 'billingAgent/CHANGE_PAYOR',
  CHANGE_STATE = 'billingAgent/CHANGE_STATE',
  CHANGE_ZIP = 'billingAgent/CHANGE_ZIP',
  CHANGE_SIGNATURE_STATE = 'billingAgent/CHANGE_SIGNATURE_STATE',
  CHANGE_DATE_SIGNED = 'billingAgent/CHANGE_DATE_SIGNED',
  CHANGE_AUTHORIED_DATE = 'billingAgent/CHANGE_AUTHORIED_DATE',
  CHANGE_INK = 'billingAgent/CHANGE_INK',
  GET_CASE_NAME = 'billingAgent/GET_CASE_NAME',
  GET_APP_NUMBER = 'billingAgent/GET_APP_NUMBER',
  GET_BILLING_MODE = 'billingAgent/GET_BILLING_MODE',
  GET_BILLING_MODE_CASE_NUMBER = 'billingAgent/GET_BILLING_MODE_CASE_NUMBER',
  CHECK_CASE_NUMBER_BILLING = 'billingAgent/CHECK_CASE_NUMBER_BILLING',
  GET_FORM_NUMBER_MESSAGE = 'billingAgent/GET_FORM_NUMBER_MESSAGE',
  CHANGE_USER_FORM_NUMBER = 'billingAgent/CHANGE_USER_FORM_NUMBER',
  GET_CASE_NUMBER_MESSAGE = 'billingAgent/GET_CASE_NUMBER_MESSAGE',
  CHANGE_USER_CASE_NUMBER = 'billingAgent/CHANGE_USER_CASE_NUMBER',
  CHANGE_PAYROLL = 'billingAgent/CHANGE_PAYROLL',
  CHANGE_DIRECT_BILL = 'billingAgent/CHANGE_DIRECT_BILL',
  CHANGE_PAC = 'billingAgent/CHANGE_PAC',
  CHANGE_FLORIDA_LICENSE = 'billingAgent/CHANGE_FLORIDA_LICENSE',
  GET_ACH_TRANSIT = 'billingAgent/GET_ACH_TRANSIT',
  GET_ACH_ACCOUNT_NUMBER = 'billingAgent/GET_ACH_ACCOUNT_NUMBER',
  GET_ACH_PAYOR_NAME = 'billingAgent/GET_ACH_PAYOR_NAME',
  GET_ACH_ACCOUNT_TYPE = 'billingAgent/GET_ACH_ACCOUNT_TYPE'
}

export const isBillingAgentAction = (action: any): action is BillingAgentAction =>
  action.type in reverseEnum(BillingAgentActionType);

export const changeCaseNumber = (caseNumber: Async<string>) =>
  createAction(BillingAgentActionType.CHANGE_CASE_NUMBER, {caseNumber});
export const changeAsyncCaseNumber = (caseNumber: Async<string>) =>
  createAction(BillingAgentActionType.CHANGE_ASYNC_CASE_NUMBER, {caseNumber});
export const changeUserCaseNumber = (caseNumber: string) =>
  createAction(BillingAgentActionType.CHANGE_USER_CASE_NUMBER, {caseNumber});
export const changeCaseNumberError = (caseNumber: string) =>
  createAction(BillingAgentActionType.GET_CASE_NUMBER_MESSAGE, {caseNumber});
export const changeControlNumber = (controlNumber: string) =>
  createAction(BillingAgentActionType.CHANGE_CONTROL_NUMBER, {controlNumber});
export const changeCaseName = (caseName: string) => createAction(BillingAgentActionType.CHANGE_CASE_NAME, {caseName});
export const changeTransit = (transit: string) => createAction(BillingAgentActionType.CHANGE_TRANSIT, {transit});
export const getAchTransitNumber = (achTransitNumber: string) => 
  createAction(BillingAgentActionType.GET_ACH_TRANSIT, {achTransitNumber});
export const getAchAccountNumber = (achAccountNumber: string) => 
  createAction(BillingAgentActionType.GET_ACH_ACCOUNT_NUMBER, {achAccountNumber});
export const getAchPayerName = (achPayerName: string) => 
  createAction(BillingAgentActionType.GET_ACH_PAYOR_NAME, {achPayerName});
export const getAchAccountType = (achAccountType: string) => 
  createAction(BillingAgentActionType.GET_ACH_ACCOUNT_TYPE, {achAccountType});
export const changeAccount = (account: string) => createAction(BillingAgentActionType.CHANGE_ACCOUNT, {account});
export const changeDraftDay = (draftDay: string) => createAction(BillingAgentActionType.CHANGE_DRAFT_DAY, {draftDay});
export const getAchDraftDay = (achDraftDay: string) =>
  createAction(BillingAgentActionType.GET_ACH_DRAFTDAY, {achDraftDay});
export const changeBillingMode = (billingMode: string) =>
  createAction(BillingAgentActionType.CHANGE_BILLING_MODE, {billingMode});
export const changeIssueDate = (issueDate: Date | '') =>
  createAction(BillingAgentActionType.CHANGE_ISSUE_DATE, {issueDate});
export const changeState = (state: string) => createAction(BillingAgentActionType.CHANGE_STATE, {state});
export const changeZip = (zip: ZipCode) => createAction(BillingAgentActionType.CHANGE_ZIP, {zip});
export const changeFormNumber = (formNumber: Async<UserAssignedFormNumber>) =>
  createAction(BillingAgentActionType.CHANGE_FORM_NUMBER, {formNumber});
export const changeUserFormNumber = (
  formNumber: string,
  documentShortName: string,
  fipscoDocumentName: string,
  documentLongName: string,
  documentName: string
) =>
  createAction(BillingAgentActionType.CHANGE_USER_FORM_NUMBER, {
    formNumber,
    documentShortName,
    fipscoDocumentName,
    documentLongName,
    documentName,
  });
export const changeFormNumberError = (formNumber: string) =>
  createAction(BillingAgentActionType.GET_FORM_NUMBER_MESSAGE, {formNumber});
export const changeElectronicDelivery = (electronicDelivery: boolean) =>
  createAction(BillingAgentActionType.CHANGE_ELECTRONIC_DELIVERY, {electronicDelivery});
export const changePayor = (payor: string) => createAction(BillingAgentActionType.CHANGE_PAYOR, {payor});
export const changeSignatureState = (signatureState: string) =>
  createAction(BillingAgentActionType.CHANGE_SIGNATURE_STATE, {signatureState});
export const changeDateSigned = (dateSigned: Date | '') =>
  createAction(BillingAgentActionType.CHANGE_DATE_SIGNED, {dateSigned});
export const changeauthorizedDate = (achAuthorizationDate: Date | '') =>
  createAction(BillingAgentActionType.CHANGE_AUTHORIED_DATE, {achAuthorizationDate});
export const changeInk = (ink: boolean) => createAction(BillingAgentActionType.CHANGE_INK, {ink});
export const changeFloridaLicense = (floridaLicense: boolean) =>
  createAction(BillingAgentActionType.CHANGE_FLORIDA_LICENSE, {floridaLicense});
export const getCaseNameByCaseNumber = (caseNumber: string) =>
  createAction(BillingAgentActionType.GET_CASE_NAME, {caseNumber});
export const getBillingModes = (applicationType: ApplicationType) =>
  createAction(BillingAgentActionType.GET_BILLING_MODE, {applicationType});
export const checkCaseNumberBillingMode = (caseNumber: string) =>
  createAction(BillingAgentActionType.CHECK_CASE_NUMBER_BILLING, {caseNumber});
export const getBillingModefromCaseNumber = (billingMode: string) =>
  createAction(BillingAgentActionType.GET_BILLING_MODE_CASE_NUMBER, {billingMode});
export const asyncCaseNumber = (caseNumber: Async<string>) =>
  createAction(BillingAgentActionType.CHANGE_ASYNC_CASE_NUMBER, {caseNumber});
export const validateFormNumber = (formNumber: string) =>
  createAction(BillingAgentActionType.GET_APP_NUMBER, {formNumber});
export const changePayroll = (payroll: boolean) => createAction(BillingAgentActionType.CHANGE_PAYROLL, {payroll});
export const changeDirectBill = (directBill: boolean) =>
  createAction(BillingAgentActionType.CHANGE_DIRECT_BILL, {directBill});
export const changePac = (pac: boolean) => createAction(BillingAgentActionType.CHANGE_PAC, {pac});

export type BillingAgentAction =
  | ReturnType<typeof changeCaseNumber>
  | ReturnType<typeof changeUserCaseNumber>
  | ReturnType<typeof changeCaseNumberError>
  | ReturnType<typeof changeControlNumber>
  | ReturnType<typeof changeCaseName>
  | ReturnType<typeof changeTransit>
  | ReturnType<typeof changeAccount>
  | ReturnType<typeof changeDraftDay>
  | ReturnType<typeof changeBillingMode>
  | ReturnType<typeof changeIssueDate>
  | ReturnType<typeof changeState>
  | ReturnType<typeof changeZip>
  | ReturnType<typeof changeFormNumber>
  | ReturnType<typeof changeUserFormNumber>
  | ReturnType<typeof changeElectronicDelivery>
  | ReturnType<typeof changePayor>
  | ReturnType<typeof changeSignatureState>
  | ReturnType<typeof changeDateSigned>
  | ReturnType<typeof changeauthorizedDate>
  | ReturnType<typeof changeInk>
  | ReturnType<typeof changeFloridaLicense>
  | ReturnType<typeof changeFormNumberError>
  | ReturnType<typeof changePayroll>
  | ReturnType<typeof changeDirectBill>
  | ReturnType<typeof changePac>
  | ReturnType<typeof getCaseNameByCaseNumber>
  | ReturnType<typeof asyncCaseNumber>
  | ReturnType<typeof checkCaseNumberBillingMode>
  | ReturnType<typeof getBillingModefromCaseNumber>
  | ReturnType<typeof getAchTransitNumber>
  | ReturnType<typeof getAchAccountNumber>
  | ReturnType<typeof getAchDraftDay>
  | ReturnType<typeof getAchPayerName>
  | ReturnType<typeof getAchAccountType>;

type BillingAgentState = BillingAgent;

export default (state: BillingAgentState, action: BillingAgentAction): BillingAgentState => {
  switch (action.type) {
    case BillingAgentActionType.CHANGE_CASE_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeCaseNumber(action.payload.caseNumber),
        Ordinary: O.changeCaseNumber(action.payload.caseNumber),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_CASE_NUMBER_MESSAGE:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeCaseNumberError(action.payload.caseNumber),
        Ordinary: O.changeCaseNumberError(action.payload.caseNumber),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_USER_CASE_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeUserCaseNumber(action.payload.caseNumber),
        Ordinary: O.changeUserCaseNumber(action.payload.caseNumber),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_TRANSIT:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeTransit(action.payload.transit),
        Ordinary: O.changeTransit(action.payload.transit),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_ACH_TRANSIT:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.getAchTransitNumber(action.payload.achTransitNumber),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_ACH_ACCOUNT_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.getAchAccountNumber(action.payload.achAccountNumber),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_ACH_DRAFTDAY:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.getAchDraftDay(action.payload.achDraftDay),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_ACH_PAYOR_NAME:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.getAchPayerName(action.payload.achPayerName),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_ACH_ACCOUNT_TYPE:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.getAchAccounType(action.payload.achAccountType),
        _: () => state,
      })(state);
    case BillingAgentActionType.GET_CASE_NAME:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeCaseNumber(new Loading(action.payload.caseNumber)),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHECK_CASE_NUMBER_BILLING:
      return matchBillingAgentByType<BillingAgent>({
        Group: () => state,
        Ordinary: O.changeAsyncCaseNumber(new Loading()),
        NewYork: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_ASYNC_CASE_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: () => state,
        Ordinary: O.changeAsyncCaseNumber(action.payload.caseNumber),
        NewYork: () => state,
      })(state);
    case BillingAgentActionType.GET_BILLING_MODE_CASE_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: () => state,
        Ordinary: O.changeAsyncBillingModeCaseNumber(action.payload.billingMode),
        NewYork: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_CASE_NAME:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeCaseName(action.payload.caseName),
        Ordinary: O.changeCaseName(action.payload.caseName),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_CONTROL_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeControlNumber(action.payload.controlNumber),
        NewYork: NY.changeControlNumber(action.payload.controlNumber),
        Ordinary: O.changeControlNumber(action.payload.controlNumber),
      })(state);
    case BillingAgentActionType.CHANGE_ACCOUNT:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeAccount(action.payload.account),
        Ordinary: O.changeAccount(action.payload.account),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_DRAFT_DAY:
      return matchBillingAgentByType<BillingAgent>({
        NewYork: NY.changeDraftDay(action.payload.draftDay),
        Ordinary: O.changeDraftDay(action.payload.draftDay),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_BILLING_MODE:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeBillingMode(action.payload.billingMode),
        NewYork: NY.changeBillingMode(action.payload.billingMode),
        Ordinary: O.changeBillingMode(action.payload.billingMode),
      })(state);
    case BillingAgentActionType.CHANGE_ISSUE_DATE:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeIssueDate(action.payload.issueDate),
        Group: G.changeIssueDate(action.payload.issueDate),
        NewYork: NY.changeIssueDate(action.payload.issueDate),
      })(state);
    case BillingAgentActionType.CHANGE_STATE:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeState(action.payload.state),
        Group: G.changeState(action.payload.state),
        NewYork: NY.changeState(action.payload.state),
      })(state);
    case BillingAgentActionType.CHANGE_ZIP:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeZip(action.payload.zip),
        Group: G.changeZip(action.payload.zip),
        NewYork: NY.changeZip(action.payload.zip),
      })(state);
    case BillingAgentActionType.GET_FORM_NUMBER_MESSAGE:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeFormNumberError(action.payload.formNumber),
        NewYork: NY.changeFormNumberError(action.payload.formNumber),
        Ordinary: O.changeFormNumberError(action.payload.formNumber),
      })(state);
    case BillingAgentActionType.CHANGE_FORM_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeFormNumber(action.payload.formNumber),
        NewYork: NY.changeFormNumber(action.payload.formNumber),
        Ordinary: O.changeFormNumber(action.payload.formNumber),
      })(state);
    case BillingAgentActionType.CHANGE_USER_FORM_NUMBER:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeUserFormNumber(
          action.payload.formNumber,
          action.payload.documentShortName,
          action.payload.fipscoDocumentName,
          action.payload.documentLongName,
          action.payload.documentName
        ),
        NewYork: NY.changeUserFormNumber(
          action.payload.formNumber,
          action.payload.documentShortName,
          action.payload.fipscoDocumentName,
          action.payload.documentShortName,
          action.payload.fipscoDocumentName
        ),
        Ordinary: O.changeUserFormNumber(
          action.payload.formNumber,
          action.payload.documentShortName,
          action.payload.fipscoDocumentName,
          action.payload.documentShortName,
          action.payload.fipscoDocumentName
        ),
      })(state);
    case BillingAgentActionType.CHANGE_ELECTRONIC_DELIVERY:
      return matchBillingAgentByType<BillingAgent>({
        Group: G.changeElectronicDelivery(action.payload.electronicDelivery),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_PAYOR:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changePayor(action.payload.payor),
        Group: G.changePayor(action.payload.payor),
        NewYork: NY.changePayor(action.payload.payor),
      })(state);
    case BillingAgentActionType.CHANGE_SIGNATURE_STATE:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeSignatureState(action.payload.signatureState),
        NewYork: NY.changeSignatureState(action.payload.signatureState),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_DATE_SIGNED:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeDate(action.payload.dateSigned),
        Group: G.changeDateSigned(action.payload.dateSigned),
        NewYork: NY.changeDate(action.payload.dateSigned),
      })(state);
    case BillingAgentActionType.CHANGE_AUTHORIED_DATE:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeAuthorizedDate(action.payload.achAuthorizationDate),
        Group: G.changeAuthorizedDate(action.payload.achAuthorizationDate),
        NewYork: NY.changeAuthorizedDate(action.payload.achAuthorizationDate),
      })(state);
    case BillingAgentActionType.CHANGE_INK:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeInk(action.payload.ink),
        NewYork: NY.changeInk(action.payload.ink),
        Group: G.changeInk(action.payload.ink),
      })(state);
    case BillingAgentActionType.CHANGE_FLORIDA_LICENSE:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeFloridaLicense(action.payload.floridaLicense),
        _: () => state,
      })(state);
    case BillingAgentActionType.CHANGE_PAYROLL:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changePayroll(action.payload.payroll),
        NewYork: NY.changePayroll(action.payload.payroll),
        Group: G.changePayroll(action.payload.payroll),
      })(state);
    case BillingAgentActionType.CHANGE_DIRECT_BILL:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changeDirectBill(action.payload.directBill),
        NewYork: NY.changeDirectBill(action.payload.directBill),
        Group: G.changeDirectBill(action.payload.directBill),
      })(state);
    case BillingAgentActionType.CHANGE_PAC:
      return matchBillingAgentByType<BillingAgent>({
        Ordinary: O.changePac(action.payload.pac),
        NewYork: NY.changePac(action.payload.pac),
        Group: G.changePac(action.payload.pac),
      })(state);
    default:
      return state;
  }
};
